module.exports = "/images/vinnova.png?bc3f0d9021be45607c6a248a335c1288";